import {Record} from 'immutable';

class Rectangle extends Record({
    uuid: undefined,
    parentUuid: undefined,
    height: undefined,
    width: undefined,
    x: undefined,
    y: undefined,
    tool: "empty",
    color: null,
    image: undefined,
    fontColor: undefined,
    fontSize: undefined,
    transparency: undefined,
    name: "",
    link: "",
    description: "",
    layout: undefined,
    orderIndex: undefined,
    users: []
}) {
}

export default Rectangle;
